import React from 'react';
import { Button } from 'components';
import { Props } from 'types/modals';
import Base from '../../base';

const UnregisterEmployeeModal = ({ closing, onClose }: Props) => {
  const handleConfirm = () => {
    onClose({
      doUnregister: true,
      sendWrittenWarning: false
    });
  };

  const handleCancel = () => {
    onClose({ doUnregister: false });
  };

  return (
    <Base
      header="Unregister"
      closing={closing}
      onClose={onClose}
      size="md"
      footer={
        <>
          <Button text="Cancel" variant="secondary" onClick={handleCancel} />
          <Button text="Confirm" onClick={handleConfirm} />
        </>
      }
    >
      <p>Are you sure you want to unregister this employee?</p>
    </Base>
  );
};

export default UnregisterEmployeeModal;
